<template>
  <div v-if="!isMobile">
    <div class="column landing_recent">
      <div class="column title_recent_tx">
        <h1>
          {{ $tc("msg.recent_transactions", 1) }}
        </h1>

        <router-link to="/transactions/deposits" class="all_transactions">{{
          $t("msg.all_transactions")
        }}</router-link>
      </div>
      <div class="columns landing_recent_header"></div>
      <div
        class="columns landing_recent_body border-bottom-grey"
        v-for="transaction in recentTransactions"
        :key="transaction.id"
      >
        <div class="column" style="display: flex; align-items: center">
          <p>{{ fixTimeZone(transaction.createdAt) }} UTC -3</p>
        </div>

        <div class="column" style="display: flex; align-items: center">
          <p>{{ $t(`msg.${transaction.type}`) | upper }}</p>
        </div>

        <div class="column" style="display: flex; align-items: center">
          <div
            class="landing_recent_body_icon icon_class_2 background_"
            :class="'background_' + transaction.status"
          ></div>
          <p class="dis_inb val_txtb uppercase">
            {{ $t(`msg.${transaction.status}`) }}
          </p>
        </div>
        <div class="column tal_r" style="display: flex; align-items: center">
          <p>
            <span v-if="transaction.amount"
              >{{ currencyFormat(transaction.amount) }}
              {{ symbAjust(transaction.currencySymbol) }}</span
            >
            <span v-else></span><br />
          </p>
        </div>
      </div>
      <div class="column tal_c" v-if="recentTransactions == ''">
        <p>{{ $t("msg.no_rec_transactions_found") }}</p>
      </div>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" type="checkbox" id="transactions" />
      <label class="tab-label">
        {{ $tc("msg.recent_transactions", 1) }}
        <router-link to="/transactions/deposits" class="all_transactions">
          {{ $t("msg.all_transactions") }}
        </router-link>
      </label>

      <div class="tab-content">
        <div class="landing_recent text_sm">
          <div
            class="columns column landing_recent_body border-bottom-grey"
            v-for="transaction in recentTransactions"
            :key="transaction.id"
          >
            <div class="column">
              <p>{{ fixTimeZone(transaction.createdAt) }} UTC -3</p>
            </div>

            <div class="column">
              <p>{{ $t(`msg.${transaction.type}`) | upper }}</p>
            </div>

            <div class="column">
              <div
                class="landing_recent_body_icon icon_class_2 background_"
                :class="'background_' + transaction.status"
              ></div>
              <p class="dis_inb val_txtb uppercase">
                {{ $t(`msg.${transaction.status}`) }}
              </p>
            </div>
            <div class="column">
              <p>
                <span v-if="transaction.amount"
                  >{{ transaction.amount | decimalsCrypto(8) }}
                  {{ symbAjust(transaction.currencySymbol) }}</span
                >
                <span v-else></span>
              </p>
            </div>
          </div>
          <div class="column tal_c" v-if="recentTransactions == ''">
            <p>{{ $t("msg.no_rec_transactions_found") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.startInterval();
    this.checkIfMobile();
  },
  mounted() {
    this.getRecentTransactions();
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    updateActive: "",
    recentTransactions: "",
    isMobile: "",
    myBalanceExpand: false,
  }),
  components: {},
  methods: {
    currencyFormat(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    toggleMenu() {
      this.myBalanceExpand = !this.myBalanceExpand;
    },

    async getRecentTransactions() {
      try {
        let resp = await this.$store.dispatch("getTransactions");

        this.recentTransactions = resp.data;
        this.sortTransactionsByCreatedAt(this.recentTransactions);
      } catch (e) {
        this.logError(e);
      }
    },

    symbAjust(el) {
      if (el == "BLU") {
        return "BLUE";
      } else {
        return el;
      }
    },

    sortTransactionsByCreatedAt(transactionsArray) {
      transactionsArray.sort((a, b) => {
        if (a.createdAt < b.createdAt) return 1;
        if (a.createdAt > b.createdAt) return -1;
        return 0;
      });

      for (let i = 0; i < transactionsArray.length; i++) {
        if (transactionsArray[i].status == "failed") {
          transactionsArray.splice(i, 1);
        }
      }

      if (transactionsArray.length > 6) {
        transactionsArray = transactionsArray.slice(0, 6);
      }
      this.recentTransactions = transactionsArray;
    },

    startInterval() {
      this.updateActive = setInterval(this.getRecentTransactions, 60000);
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="css">
.landing_recent_body_icon {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/private/landing/LandingRecentTransactions.vue